import { status } from '../../config.ts'
import { employeesPage1, userDetail, usersPage1 } from './data.ts'
import { wait } from '@/__mocks__/util/async.ts'

export default [
  {
    method: 'GET',
    path: '/users?limit=20',
    reply: async () => {
      await wait()
      return [status.ok, usersPage1]
    }
  },
  {
    method: 'GET',
    path: '/employee/catalog',
    reply: async () => {
      await wait()
      return [status.ok, employeesPage1]
    }
  },
  {
    method: 'GET',
    path: '/users/1',
    reply: async () => {
      await wait()
      return [status.ok, userDetail]
    }
  },
  {
    method: 'POST',
    path: '/users',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'DELETE',
    path: '/users/1',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'PATCH',
    path: '/users/1',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'PATCH',
    path: '/users/1/status',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'PATCH',
    path: '/users/2/status',
    reply: async () => {
      await wait()
      return [status.error]
    }
  },
  {
    method: 'PATCH',
    path: '/users/2/lock',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'PATCH',
    path: '/users/2/unlock',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'GET',
    path: '/users/qr',
    reply: async () => {
      await wait()
      return [status.ok, 'mock-qr-vendor']
    }
  },
  {
    method: 'GET',
    path: '/users/45/qr',
    reply: async () => {
      await wait()
      return [status.ok, 'mock-qr-user-45']
    }
  },
  {
    method: 'GET',
    path: '/users/46/qr',
    reply: async () => {
      await wait()
      return [status.ok, 'mock-qr-user-46']
    }
  }
]
